module.exports = __webpack_public_path__ + "static/media/NotoSansHK-Regular.945b609f.otf";